import React from "react";
import classNames from "classnames";
import { makeStyles } from "@mui/styles";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import styles from '../styles/staticPages.js';
import Parallax from "components/Parallax/Parallax";
import { useTranslation } from "react-i18next";
import { colors } from "components/Theme/WebTheme.js";


const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function AboutAccount(props) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const classes = useStyles();
  const { ...rest } = props;

  return (
    <div style={{ margin: '-8px' }}>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "primary"
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/header-back.jpg").default} />
      <div className={classNames(classes.main, classes.mainRaised)}>

        <div className={classes.container}>
          <br />
          <h1 style={{ textAlign: isRTL === 'rtl' ? 'right' : 'left', position: "relative", marginTop: "30px", minHeight: "32px", color: colors.Header, textDecoration: "none", [isRTL === "rtl" ? "marginRight" : "marginRight"]: isRTL ? "30px" : "0px", wordBreak: "break-word" }}>Como excluir sua conta (Passageiro ou Motorista)</h1>
          <h4 className={isRTL === "rtl" ? classes.rtlDescription : classes.ltrDescription} >
            Se você chegou até aqui, é porque está pensando em deixar de usar nossos serviços — e isso, sinceramente, nos entristece. 😔
            <br />
            Mas acima de tudo, valorizamos o seu tempo, sua privacidade e o nosso compromisso com a transparência.
            Por isso, queremos deixar claro que não há burocracia para encerrar sua conta. Você pode fazer isso de forma simples e rápida, diretamente pelo aplicativo.
            <br/><br/>
            📲 Passo a passo para excluir sua conta:
            Faça login na sua conta no app Xama.
            <br/><br/>
            Vá até o menu “Configurações”.
            <br/><br/>
            Acesse a opção “Configurações do perfil”.
            <br/><br/>
            Toque no botão vermelho “Excluir conta”.
            <br/><br/>
            Confirme a exclusão na mensagem de alerta que será exibida.
            <br/><br/>
            🧹 O que acontece depois?
            Após a confirmação, todos os seus dados serão permanentemente apagados, incluindo:
            <br/>
            Nome
            <br/><br/>
            Foto de perfil
            <br/><br/>
            E-mail
            <br/><br/>
            Senha
            <br/><br/>
            Dados de navegação
            <br/><br/>
            Histórico de viagens e interações
            <br/><br/>
            ⚠️ Essa ação é irreversível. Todos os dados são removidos dos nossos servidores de forma definitiva.
            <br/>
            Se tiver qualquer dúvida ou precisar de ajuda, nossa equipe de suporte está pronta para te atender.
          </h4>
          <br />
        </div>
      </div>

      <Footer />
    </div>
  );
}
